import React from 'react'
import './_footer.scss'

const Footer = () => {
  return (
    <div>
      <footer className='footer'>
        <a href='/#'>
          <p className='footer-text'>https://www.solomka.dev 2023</p>
        </a>
      </footer>
    </div>
  )
}

export default Footer
